<script setup lang="ts">
import PlusIcon from '../assets/plus-icon.svg?component';
import HeartIcon from '../assets/heart-icon.svg?component';
import GoogleLogo from '../assets/google-logo.svg?component';
import DocumentIcon from '../assets/document.svg?component';
import ListIcon from '../assets/list-icon.svg?component';
import WarningIcon from '../assets/icon-warning.svg?component';
import AbsenceIcon from '../assets/absence-icon.svg?component';
import HolidayIcon from '../assets/holiday-icon.svg?component';
import QuotaMonitoringIcon from '../assets/quota-monitoring-icon.svg?component';
import type { IconType } from '@/models/Icon';

withDefaults(defineProps<{
	icon?: IconType;
}>(), {
	icon: 'plus',
});
</script>

<template>
	<div>
		<div
			v-if="icon === 'google'"
			class="w-10 h-10 rounded-full bg-white bg-opacity-10 flex items-center justify-center"
		>
			<GoogleLogo class="w-[25px]" />
		</div>
		<div
			v-if="icon === 'plus'"
			class="w-10 h-10 rounded-full bg-primary-100 bg-opacity-25 flex items-center justify-center"
		>
			<PlusIcon class="w-[20px] h-[20px]" />
		</div>
		<div
			v-if="icon === 'heart'"
			class="w-10 h-10 rounded-full bg-secondary bg-opacity-25 flex items-center justify-center"
		>
			<HeartIcon class="w-[18px] h-[22px]" />
		</div>
		<div
			v-if="icon === 'doc'"
			class="w-10 h-10 rounded-full bg-success bg-opacity-25 flex items-center justify-center"
		>
			<DocumentIcon class="w-[18px] h-[22px]" />
		</div>
		<div
			v-if="icon === 'list'"
			class="w-10 h-10 rounded-full bg-gray bg-opacity-25 flex items-center justify-center"
		>
			<ListIcon class="w-[18px] h-[22px]" />
		</div>
		<div
			v-if="icon === 'warning'"
			class="w-10 h-10 rounded-full bg-gray bg-opacity-25 flex items-center justify-center"
		>
			<WarningIcon class="w-[18px] h-[22px]" />
		</div>
		<div
			v-if="icon === 'absence'"
			class="w-10 h-10 rounded-full bg-gray bg-opacity-25 flex items-center justify-center"
		>
			<AbsenceIcon class="w-[18px] h-[22px]" />
		</div>
		<div
			v-if="icon === 'holiday'"
			class="w-10 h-10 rounded-full bg-gray bg-opacity-25 flex items-center justify-center"
		>
			<HolidayIcon class="w-[18px] h-[22px]" />
		</div>
		<div
			v-if="icon === 'quota-monitoring'"
			class="w-10 h-10 rounded-full bg-gray bg-opacity-25 flex items-center justify-center"
		>
			<QuotaMonitoringIcon class="w-[22px] h-[26px]" />
		</div>
	</div>
</template>
